const faqDataTr = [
  {
    text: "Shipping & Delivery", // değişmesin
    faqs: [
      {
        id: "1",
        question: "ماذا يحدث بعد تقديم طلبي؟",
        answer:
          "بعد تأكيد طلبك، سيتم إرسال بريد إلكتروني إليك لتأكيد الطلب، ثم نقوم بتحضير المنتج الخاص بك وإرساله من خلال شركات الشحن المتعاقدة معنا (DHL، UPS وFEDEX).",
      },
      {
        id: "2",
        question: "ما هي رسوم الشحن؟",
        answer:
          "لن تقلق بشأن رسوم الشحن، فهي هدية من عائلة Mukemel لعملائنا الأعزاء.",
      },
      {
        id: "3",
        question: "كيف سيصلني طلبي؟",
        answer:
          "بعد تأكيد الطلب والدفع، يتم تجهيز طلبات التماثيل خلال 3 أيام عمل. أيام العمل هي من الإثنين إلى الجمعة، باستثناء العطلات الرسمية. لا تتم معالجة أو شحن الطلبات أيام السبت والأحد والعطل الرسمية في تركيا. الطلبات التي تُقدّم في هذه الأيام تتم معالجتها في أول يوم عمل تالٍ. التوصيل يعتمد على شركات الشحن (DHL، UPS وFEDEX) وقد يتأثر بحالة الطقس. في مواسم العروض مثل الجمعة السوداء والاثنين الإلكتروني، قد تستغرق الطلبات وقتاً أطول من المعتاد.",
      },
    ],
  },
  {
    text: "Exchanges & Returns", // değişmesin
    faqs: [
      {
        id: "1",
        question: "ماذا أفعل إذا تم تسليم منتجي مكسورًا؟",
        answer:
          "وفقًا لسياساتنا، يجب على العميل الذي استلم الطرد مكسورًا التواصل معنا خلال 24 ساعة من التسليم. باستثناء العطور. بعد هذه المدة، نعتبر أن المنتج تم تسليمه دون مشاكل ولا نتحمل أي مسؤولية.",
      },
      {
        id: "2",
        question: "ماذا أفعل إذا لم يعجبني المنتج؟",
        answer:
          "وفقًا لسياساتنا، نقدم للعملاء الحق في الإرجاع خلال 14 يومًا من تاريخ الشحن (باستثناء طلبات العطور). إذا مرّت 14 يومًا، فللأسف لا يمكننا تقديم استرداد. سيتم خصم رسوم من الطلب في حالة الإرجاع، ويتم تقييم كل حالة على حدة. يجب أن يكون المنتج غير مستخدم، وفي حالته الأصلية مع العبوة الأصلية والبطاقة المرفقة. رسوم الشحن والجمارك على عاتق المشتري.",
      },
      {
        id: "3",
        question: "هل يمكنني إرجاع المنتجات المخصصة؟",
        answer: "لا نقبل إرجاع أي منتج تم طلبه مع تخصيص شخصي.",
      },
    ],
  },
  {
    text: "Product Orders", // değişmesin
    faqs: [
      {
        id: "1",
        question: "هل تتوفر إمكانية الشراء بالجملة؟",
        answer:
          "نعم، نقدم إمكانية الشراء بالجملة. لمزيد من المعلومات، يمكنك التواصل معنا عبر البريد الإلكتروني: customer.support@mukemel.com",
      },
      {
        id: "2",
        question: "ما هي طرق الدفع المتاحة؟",
        answer: "نستخدم بوابة دفع موثوقة وآمنة لجميع معاملاتنا عبر الإنترنت.",
      },
      {
        id: "3",
        question: "ماذا أفعل إذا لم يكن المنتج متوفرًا في المخزون؟",
        answer:
          "بالنسبة للمنتجات غير المتوفرة، يرجى التواصل معنا عبر البريد الإلكتروني: customer.support@mukemel.com لإضافة بريدك الإلكتروني إلى قائمة الانتظار. سيتم إعلامك بمجرد توفر المنتج مرة أخرى.",
      },
    ],
  },
  {
    text: "Perfume Policies", // değişmesin
    faqs: [
      {
        id: "1",
        question: "ما هي طرق الدفع المتاحة؟",
        answer: "نستخدم بوابة دفع موثوقة وآمنة لجميع معاملاتنا عبر الإنترنت.",
      },
      {
        id: "2",
        question: "هل تتوفر إمكانية الشراء بالجملة؟",
        answer:
          "نعم، نقدم إمكانية الشراء بالجملة. لمزيد من المعلومات، يمكنك التواصل معنا عبر البريد الإلكتروني: customer.support@mukemel.com",
      },
      {
        id: "3",
        question: "ماذا يحدث بعد تقديم طلبي؟",
        answer:
          "بعد تأكيد طلبك، سيتم إرسال بريد إلكتروني إليك لتأكيد الطلب، ثم نقوم بتحضير المنتج الخاص بك وإرساله من خلال شركات الشحن المتعاقدة معنا (DHL، UPS وFEDEX).",
      },
      {
        id: "4",
        question: "ما هي رسوم الشحن؟",
        answer:
          "لن تقلق بشأن رسوم الشحن، فهي هدية من عائلة Mukemel لعملائنا الأعزاء.",
      },
      {
        id: "5",
        question: "كيف سأستلم طلبي من العطور؟",
        answer:
          "بعد تأكيد طلبك والدفع، تبدأ مرحلة إنتاج عطرك وسيصلك خلال 14 يوم عمل. أيام العمل من الاثنين إلى الجمعة، باستثناء العطلات الرسمية. لا نقوم بمعالجة أو شحن الطلبات أيام السبت والأحد والعطل. الطلبات التي تتم في هذه الأيام تُعالج في يوم العمل التالي. يعتمد التوصيل على شركات الشحن (DHL، UPS وFEDEX) وقد يتأثر بالأحوال الجوية. خلال فترات التخفيضات مثل الجمعة السوداء، قد تتأخر الطلبات.",
      },
      {
        id: "6",
        question: "ماذا أفعل إذا لم يكن العطر متوفرًا في المخزون؟",
        answer:
          "نحن لا نحتفظ بعطور في المخزون. يتم إنتاج كل عطر بشكل فردي حسب الطلب، ولهذا فإن مدة التسليم تستغرق 14 يوم عمل.",
      },
      {
        id: "7",
        question: "ماذا أفعل إذا استلمت العطر مكسورًا؟",
        answer:
          "يتم تجهيز طلبات العطور بصناديق محمية وخاصة، لذلك لا يمكن أن تصل مكسورة. لذلك، لا نتحمل أي مسؤولية في هذا الخصوص.",
      },
      {
        id: "8",
        question: "ماذا أفعل إذا لم يعجبني العطر الذي طلبته؟",
        answer:
          "يُسمح بإرجاع العطور خلال 48 ساعة من استلام الطلب. بعد هذه المدة، لا نقبل الإرجاع. سيتم خصم رسوم معينة من قيمة الطلب عند الإرجاع. يجب ألا يكون الشريط اللاصق الحراري الموجود على عبوة العطر قد فُتح. إذا تم فتحه، فلن نقبل الإرجاع. أرسلنا لك أيضًا عينتين (تسترات) كهدية لتجربة الرائحة — وهي ملكك بغض النظر عن الإرجاع. رسوم الشحن والجمارك يتحملها المشتري.",
      },
      {
        id: "9",
        question: "هل يمكنني إرجاع المنتجات المخصصة؟",
        answer: "لا نقبل إرجاع أي منتج تم طلبه مع تخصيص شخصي.",
      },
    ],
  },
];
export default faqDataTr;
